// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../config/styles';

const styles = ({
  label: {
    color: GlobalStyles.color.COLOR_GREY,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
  },
  fixedWidth: {
    width: '290px !important',
  },
  width: {
    width: '100%',
  },
  select: {
    marginTop: 5,
    backgroundColor: '#F4F8FA',
    color: GlobalStyles.color.COLOR_INPUT,
    marginBottom: 10,
    height: 38,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    '&:focus': {
      color: `${GlobalStyles.color.COLOR_INPUT} !important`,
    }
  },
});

export default styles;
